<template>
	<div class="app-bodyDiv">
		<!-- //todo 上边框 -->
		<div class="app-headNav">
			<!-- 主要上边框 -->
			<headNav :headNavFlag="headNavFlag"></headNav>
			<!-- vip提示  新版本暂时不需要-->
			<!-- <headMessage></headMessage> -->
		</div>
		<!-- //todo 主要内容 -->
		<div class="app-contentDiv">
			<keep-alive>
				<router-view />
			</keep-alive>
			<!-- <div v-show="$app.loading" class="app-loading"></div> -->
		</div>
		<!-- <i-modal :open="$app.loading">加载中</i-modal> -->
		<hd-toast :data="$app.toast"></hd-toast>
		<hd-dialog :data="$app.dialog"></hd-dialog>
	</div>
</template>

<script>
import headNav from "./mycomponents/headNav";
import {registerOCPC} from "./plugins/sdk/api/index";
import hdapi from "./common/hdapi";
import {store} from "./plugins";
import Offline from "./pages/dialogs/Offline.vue";

export default {
	name: "App",
	components: {
		headNav,
	},
	data() {
		return {
			headNavFlag: true,
			isWebLoad: true,
			nowPcResult_time: null,
			fontSize: 1,
		};
	},
	watch: {
		$route(to, from) {
			console.log("from", from.path);
			console.log("to", to);
			if (to.path == "/home" || to.path == "/") {
				this.headNavFlag = true;
				console.log("在home组件的headflag", this.headNavFlag);
			} else {
				this.headNavFlag = false;
				console.log("当前的headflag", this.headNavFlag);
			}
		},
	},
	methods: {
		refresh() {},
		fontSizeSet() {
			if (screen.height >= 800 && screen.width < 1180 && this.fontSize != 1 / 1.18) {
				store.isFenBianLvChangeOver = false;
				let a = false;
				let oldscreenWidth = this.fontSize * 1920;
				if (oldscreenWidth == window.innerWidth) {
					a = true;
				}
				this.fontSize = 1 / 1.18;
				let size = {width: 1000, height: 636};
				hdapi.setWindow(size, a, true);
				document.getElementsByTagName("html")[0].style.fontSize = this.fontSize + "px";
			} else if (
				(screen.height >= 1080 || screen.height < 675) &&
				this.fontSize != screen.width / 1920
			) {
				store.isFenBianLvChangeOver = false;
				let a = false;
				let oldscreenWidth = this.fontSize * 1920;
				if (oldscreenWidth == window.innerWidth) {
					a = true;
				}
				this.fontSize = screen.width / 1920;
				let size = {width: screen.width, height: screen.height};
				hdapi.setWindow(size, a, false);
				document.getElementsByTagName("html")[0].style.fontSize = this.fontSize + "px";
			} else if (screen.height >= 675 && screen.height < 800 && this.fontSize != 1 / 1.18) {
				store.isFenBianLvChangeOver = false;
				let a = false;
				let oldscreenWidth = this.fontSize * 1920;
				if (oldscreenWidth == window.innerWidth) {
					a = true;
				}
				this.fontSize = 1 / 1.18;
				let size = {width: 1000, height: 636};
				hdapi.setWindow(size, a, true);
				document.getElementsByTagName("html")[0].style.fontSize = this.fontSize + "px";
			} else if (
				this.fontSize != 1 &&
				screen.height < 1080 &&
				screen.height >= 800 &&
				screen.width >= 1180
			) {
				store.isFenBianLvChangeOver = false;
				let a = false;
				let oldscreenWidth = this.fontSize * 1920;
				if (oldscreenWidth == window.innerWidth) {
					a = true;
				}
				this.fontSize = 1;
				let size = {width: 1180, height: 750};
				hdapi.setWindow(size, a, true);
				document.getElementsByTagName("html")[0].style.fontSize = this.fontSize + "px";
			}
		},
		async getMainPath() {
			let main_path = await hdapi.getPath("main").then((res) => {
				return res;
			});
			main_path = hdapi.split(main_path);
			main_path.splice(-1, 1);
			if (main_path[main_path.length - 1] == "app.asar") {
				main_path.splice(-1, 1);
			}
			main_path = hdapi.arrayjoin(main_path);
			console.log("主路径", main_path);
			return main_path;
		},
		async getStatistics() {
			try {
				let main_path = await this.getMainPath();
				let url = hdapi.join(main_path, "statistics.json");
				// console.log("url", url);
				let doc = await hdapi.readFile(url, "utf8");
				console.log("读取文件结果", doc);
				if (doc) return false;
			} catch (err) {
				console.error(this.$t("failtoreadfile"), err);
				return true;
			}
			// return doc ? JSON.parse(doc).statistics : false;
		},
		async setStatistics() {
			try {
				let main_path = await this.getMainPath();
				let url = hdapi.join(main_path, "statistics.json");
				console.log("url", url);
				hdapi.writeFile(url, JSON.stringify({statistics: true}));
			} catch (err) {
				console.error(this.$t("failtowritetofile"), err);
			}
		},
	},
	async resume() {},
	pause() {},
	created() {},
	async mounted() {
		let _this = this;
		this.refresh();
		await hdapi.showMainWeb();
		if (screen.height >= 800 && screen.width < 1180) {
			this.fontSize = 1 / 1.18;
		} else if (screen.height >= 1080 || screen.height < 676) {
			this.fontSize = screen.width / 1920;
		} else if (screen.height < 800) {
			this.fontSize = 1 / 1.18;
		} else this.fontSize = 1;
		window.addEventListener("offline", (e) => {
			// this.renderFile();
			_this.$dlg.show(Offline);
		});
		this.nowPcResult_time = setInterval(() => {
			_this.fontSizeSet();
		}, 500);
		let isStatistics = await this.getStatistics();
		if (isStatistics) {
			console.log("文件不存在");
			let isActive = await registerOCPC(this.$local.userLoginData);
			console.log("isActive", isActive);
			if (isActive) {
				this.setStatistics();
				if (this.$local.userLoginData) this.$local.userLoginData = null;
			}
		}
	},
	beforeDestroy() {
		this.nowPcResult_time = null;
	},
};
</script>
<style lang="less">
// .app-loading {
// 	position: fixed;
// 	top: 0;
// 	bottom: 0;
// 	left: 0;
// 	right: 0;
// 	background: rgba(128, 128, 128, 0.3);
// }
.app-bodyDiv {
	position: relative;
	height: 100%;
	box-sizing: border-box;
	padding-top: 8rem;
	background-color: #f7f8f9;
}

.app-headNav {
	height: 50rem;
	// overflow: hclassden;
	width: 100%;
}

.app-contentDiv {
	height: calc(100% - 50rem);
}
</style>
